var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 24.5,
    height: 24.5,
    rx: 6,
    fill: "#0077F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 18.8333H16.9166",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3513 8.13671L13.7838 7.70417C14.5005 6.98751 15.6624 6.98751 16.3791 7.70417C17.0958 8.42083 17.0958 9.58277 16.3791 10.2994L15.9465 10.732M13.3513 8.13671C13.3513 8.13671 13.4054 9.05587 14.2164 9.86689C15.0274 10.6779 15.9465 10.732 15.9465 10.732M13.3513 8.13671L9.3747 12.1133C9.10536 12.3826 8.97069 12.5173 8.85487 12.6658C8.71825 12.841 8.60112 13.0305 8.50554 13.231C8.42453 13.401 8.3643 13.5817 8.24385 13.9431L7.73343 15.4743M15.9465 10.732L11.97 14.7086C11.7006 14.9779 11.566 15.1126 11.4175 15.2284C11.2423 15.365 11.0528 15.4821 10.8522 15.5777C10.6822 15.6587 10.5016 15.719 10.1402 15.8394L8.60895 16.3498M8.60895 16.3498L8.23464 16.4746C8.05682 16.5339 7.86076 16.4876 7.72821 16.355C7.59567 16.2225 7.54938 16.0264 7.60866 15.8486L7.73343 15.4743M8.60895 16.3498L7.73343 15.4743",
    stroke: "white",
    strokeWidth: 1.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.b7c184289450dc7babd85321a30db828.svg";
export { ForwardRef as ReactComponent };